<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['add_sales'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="card" style="box-shadow: 0 0 2px gray;">
                  <div class="card-body">
                    <h4 class="text-center">Sale by</h4>
                    <div class="d-flex justify-content-evenly">
                      <div class="d-flex align-items-center ms-2">
                        <input style="margin-right: 2px;" type="radio" id="product_search" name="sell_mode"
                          v-model="sellMode" class="" value="Product Search" @change="clearFields" />
                        <label for="product_search" class="mb-0">
                          Product
                        </label>
                      </div>
                      <!-- <div class="d-flex align-items-center ms-2">
                        <input style="margin-right: 2px;" type="radio" id="category" name="sell_mode" v-model="sellMode" class=""
                          value="Category" @change="clearFields" />
                        <label for="category" class="mb-0">
                          Category
                        </label>
                      </div> -->
                      <div class="d-flex align-items-center ms-2">
                        <input style="margin-right: 2px;" type="radio" id="barcode" name="sell_mode" v-model="sellMode"
                          class="" value="Bar Code" @change="clearFields" />
                        <label for="barcode" class="mb-0">
                          Bar Code
                        </label>
                      </div>
                    </div>
                    <hr />
                    <form @submit.prevent="AddtoCart">

                      <div class="form-group mb-2" v-if="sellMode == 'Bar Code'">
                        <label class="mb-0">Bar Code</label>
                        <input class="form-control" v-model="bar_code" label="name" @change="FilterProductsByBarCode" />
                      </div>

                      <div class="form-group mb-2" v-if="sellMode == 'Product Search'">
                        <label class="mb-0">Product</label>
                        <multiselect v-model="product" label="name" @input="clearUnitFieldOnProductChange"
                          :options="products" :searchable="true" :filterable="true"></multiselect>
                      </div>

                      <div class="form-group mb-2" v-if="sellMode == 'Bar Code'">
                        <label class="mb-0">Product</label>
                        <input class="form-control" :value="product.name" label="name" />
                      </div>

                      <div class="form-group mb-2">
                        <label class="mb-0">Unit</label>
                        <div class="">
                          <button v-for="(i, index) in units" @click.prevent="selectUnit(i.unit_id, i.price)"
                            class="btn rounded-pill btn-sm border-dark me-2 mb-1 no-glow" :class="{ 'btn-dark': i.unit_id == unit }"
                            :key="index">{{ i.unit }}</button>
                        </div>
                      </div>
                      <i class="text-info float-end">Base Quantity : {{ this.unit.base_quantity }}</i>
                      <div class="form-group mb-2">
                        <label class="mb-0">Unit Price</label>
                        <input v-model="price" type="number" required class="form-control" />
                      </div>
                      <div class="form-group mb-2">
                        <div class="row align-items-center">
                          <label class="col-md-6 mb-0">Quantity</label>
                          <div class="col-md-6 text-info">Stock to Deduct: {{ quantity * this.unit.base_quantity || '0'
                          }}</div>
                        </div>
                        <input v-model="quantity" type="number" required min="1"
                          :max="this.product.active_quantity / this.unit.base_quantity" class="form-control" />
                      </div>
                      <i class="text-info float-start">Batch: {{ product.active_batch }}</i>
                      <i class="text-info float-end">in stock : {{ product.active_quantity }}</i>
                      <br />
                      <hr />
                      <div class="form-group">
                        <div v-if=error class="text-danger mb-1 text-center">{{ error }}</div>
                        <b-button class="btn w-100" :class="{ disabled: loader }" type="submit" variant="primary">
                          <b-spinner v-if="loader" small class="mr-1" label="Small Spinner" /><i v-else
                            class="fas fa-check-circle"></i>
                          Submit</b-button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <div class="card" style="box-shadow: 0 0 2px gray;" v-if="userData.permissions['confirm_sale'] == 1">
                  <div class="text-end p-1" v-if="this.salecarts.length > 0">
                    <button @click.prevent="refreshCart" class="btn btn-primary btn-sm" :class="{ disabled: loader2 }">
                      <b-spinner v-if="loader2" small class="mr-1" label="Small Spinner" />
                      <div v-else>Refresh Cart</div>
                    </button>
                  </div>
                  <span v-if="this.salecarts.length <= 0">
                    <div class="d-flex justify-content-center p-5">
                      <span class="mdi mdi-pill text-success display-5"></span><br />
                      <span class="h4 mt-4">No Item Selected</span>
                    </div>
                  </span>
                  <span v-else>
                    <div class="table-responsive">
                      <b-table :items="Items" :fields="Fields" responsive="sm" :busy="IsBusy">
                        <template #table-busy>
                          <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle" type="grow" small></b-spinner>
                            <strong>No Data Found</strong>
                          </div>
                        </template>
                        <template #cell(index)="data">
                          {{ data.index + 1 }}
                        </template>
                        <template #cell(product)="data">
                          {{ data.item.product.name }}
                        </template>
                        <template #cell(category)="data">
                          {{ data.item.category.name }}
                        </template>
                        <template #cell(unit)="data">
                          {{ data.item.unit.unit_name }}
                        </template>
                        <template #cell(actions)="data">
                          <b-button @click="
                            remove(data.item.id, data.item.product.name)
                            " type="button" class="btn-sm btn" variant="danger" v-b-modal.delete>
                            <i class="mdi mdi-trash-can"></i>
                          </b-button>
                        </template>
                      </b-table>
                    </div>
                    <br />
                    <div class="d-flex justify-content-between">
                      <div class="mx-3 h3">
                        Total:
                        <span class="ms-2">{{ commas(cart_total) }}</span>
                      </div>
                      <div v-if="cart_total <= amountpaid" class="mx-3 h3 text-success">
                        Change:
                        <span class="ms-2">{{
                          commas(amountpaid - cart_total)
                        }}</span>
                      </div>
                      <div v-else class="mx-3 h3 text-danger">
                        Balance:
                        <span class="ms-2">{{
                          commas(cart_total - amountpaid)
                        }}</span>
                      </div>
                    </div>
                    <hr />
                    <div class="row mx-1">

                      
                      <div class="my-2"></div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <div class="mb-2 d-flex align-items-center">
                            <div class="float-end">
                              <b-button v-if="useCustomer && userData.permissions['add_customer'] == 1"
                                class="py-1 me-1 btn-sm" v-b-modal.new-customer variant="primary"><i
                                  class="mdi mdi-plus"></i>
                              </b-button>
                            </div>
                            <div class="fw-bold">Known Customer</div>
                            <input type="checkbox" v-model="useCustomer" @click="getCustomers" class="ms-1" />
                          </div>
                          <multiselect v-if="useCustomer" v-model="customer" label="name" :options="customers">
                          </multiselect>
                          <input v-else readonly value="Random Customer" class="form-control" />
                        </div>
                      </div>

                      <div class="col-md-6 mb-2">
                        <div class="form-group">
                          <label>Pay Date</label>
                          <input readonly v-model="paydate" type="date" required class="form-control" />
                        </div>
                      </div>
                      <div class="text-center text-danger fw-bold" v-if="error">{{ error }}</div>
                      <div class="d-flex justify-content-center">
                        <div class="col-md-6">

                          <b-button class="btn w-100 mt-4 mb-2" :class="{ disabled: loader3 }" @click="SubmitExit"
                            variant="primary" :disabled="loader3">
                            <b-spinner v-if="loader3" small class="mr-1" label="Small Spinner" />

                            <i v-else class="mdi mdi-check-circle"></i> SUBMIT &
                            EXIT</b-button>
                        </div>
                        
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br /><br />
            <center>
              <span class="text-primary h6">You have no permission to Sell Medicine</span>
            </center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-customer" centered title="New Customer  " title-class="font-18" hide-footer>
      <form @submit.prevent="addCustomer">
        <div class="form-group mb-2">
          <label>Customer Name</label>
          <input v-model="name" type="text" required class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Email</label>
          <input v-model="email" type="email" class="form-control" />
        </div>
        <div class="row">
          <div class="col-md-6 form-group mb-2">
            <label for="contact">Contact</label>
            <input type="text" class="form-control" id="contact" v-model="contact" placeholder="123-45-678" required />
          </div>
          <div class="col-md-6 form-group mb-2">
            <label>Location</label>
            <input v-model="location" class="mb-3 form-control" value-field="id" text-field="name" />
          </div>
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('new-customer')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            Submit</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="delete-unit" centered title="Delete From Cart" title-class="font-18" hide-footer>
      <form @submit.prevent="removeFromCart">
        <input v-model="id" type="hidden" />
        Are you sure you want to remove the Product : <b>{{ product }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('delete-unit')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            YES</b-button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  paymentoptionMethods,
  paymentoptionComputed,
  productcategoryMethods,
  productcategoryComputed,
  salecartMethods,
  salecartComputed,
  productComputed,
  productMethods,
} from "@/state/helpers";

export default {
  page: {
    title: "Point Of Sale",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      sellMode: 'Product Search',
      bar_code: "",
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Point Of Sale",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Point Of Sale", active: true },
      ],
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "category", label: "Category", visible: true },
        { key: "product", label: "Product Name", visible: true },
        { key: "unit", label: "Unit Name", visible: true },
        { key: "price", label: "Price", visible: true },
        { key: "quantity", label: "Quantity", visible: true },
        { key: "actions", label: "Remove", visible: true },
      ],
      units: [],
      id: "",
      category: '',
      product: '',
      instock: "0",
      unit: "",
      amountpaid: 0,
      price: "",
      quantity: "1",
      description: "",
      paydate: new Date().toLocaleDateString("fr-CA"),
      payoption: null,
      customer: "",
      customers: [{ name: "Trevor" }, { name: "McDaniel" }],
      useCustomer: false,
      name: "",
      contact: "",
      email: "",
      location: "",
      loader: false,
      loader2: false,
      loader3: false,
      error: '',
    };
  },

  watch: {
    product(newVal) {
      if (!newVal || !this.unit) {
        this.price = null;
      }
    },
    unit(newVal) {
      if (!newVal || !this.product) {
        this.price = null;
      }
    },
  },
  computed: {
    ...salecartComputed,
    ...productcategoryComputed,
    ...paymentoptionComputed,
    ...productComputed,
    cart_total() {
      var total = 0;
      this.salecarts.forEach((item) => {
        var item_total = item.price * item.quantity;
        total = total + item_total;
      });
      return total;
    },
    List() {
      return this.salecarts.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.salecarts.map((d) => ({ ...d }));
    },
    Cart() {
      return this.salecarts.map((d) => ({
        id: d.id,
        unit: d.unit.id,
        product: d.product.id,
        quantity: d.quantity,
        price: d.price,
      }));
    },
    IsBusy() {
      let a = false;
      if (this.salecarts.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.fetchProducts();
    this.fetchPaymentoptions();
    this.fetchSalesCart();
    this.fetchCategories();
    this.isBusy = false;
    this.payoption = this.paymentoptions.find(
      (option) => option.set_default == 1
    );
  },
  methods: {
    ...salecartMethods,
    ...productcategoryMethods,
    ...paymentoptionMethods,
    ...productMethods,
    async refreshCart() {
      this.loader2 = true;
      await this.fetchSalesCart();
      this.loader2 = false;
      this.loader3 = false;
    },
    async clearUnitFieldOnProductChange() {
      this.unit = ''; // Clear the unit field when product is changed
      this.FilterProductUnits(); // Optionally, refetch units based on the selected product
    },
    async addCustomer() {
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("contact", this.contact);
      formData.append("location", this.location);
      formData.append("email", this.email);
      let url = "/create_customer";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.$bvModal.hide("new-customer");
          this.name = "";
          this.contact = "";
          this.email = "";
          this.location = "";
        }
      });
      const customers = await axios.get("/customers");
      this.customers = customers.data.customers;
    },

    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    remove(id, product) {
      this.id = id;
      this.product = product;
      this.$bvModal.show("delete-unit");
    },

    selectUnit(id, price){
      this.unit = id
      this.price = price
    },

    async getCustomers() {
      if (!this.useCustomer) {
        const customers = await axios.get("/customers");
        this.customers = customers.data.customers;
      }
    },

    clearFields() {
      this.product = "";
      this.bar_code = "";
      this.category = "";
      this.unit = "";
      this.price = "";
    },

    async FilterProducts() {
      this.product = ''
      let url = `/productbycategory/${this.category.id}`;
      await axios.get(url).then((response) => {
        this.products = response.data.products;
      });
    },
    async FilterProductsByBarCode() {
      let url = `/productbybarcode/${this.bar_code}`;
      await axios.get(url).then((response) => {
        this.product = response.data.product;

        let url = `/unitsbyproduct/${this.product.id}`;
        axios.get(url).then((response) => {
          this.units = response.data.units;
        });
      });
    },
    async FilterProductUnits() {
      this.units = ''
      let url = `/unitsbyproduct/${this.product.id}`;
      await axios.get(url).then((response) => {
        this.units = response.data.units;
      });
    },

    async FilterPrice() {
      let url = `/productbyunitprice/${this.unit.unit_id},${this.product.id}`;
      await axios.get(url).then((response) => {
        this.price = response.data.price;
      });
    },
    async AddtoCart() {
      this.loader = true;
      this.error = '';
      let formData = new FormData();
      
      if (this.category && this.category.id != null) {
        // If a category is selected, use its ID
        formData.append("category", this.category.id);
      } else if (this.product && this.product.category && this.product.category.id != null) {
        // If no category is selected, use product's category ID
        formData.append("category", this.product.category.id);
      } else {
        // Fallback to product's category if both are not available
        formData.append("category", this.product.category);
      }
      formData.append("product", this.product.id);
      formData.append("unit", this.unit);
      formData.append("price", this.price);
      formData.append("quantity", this.quantity);
      let url = "/addtocart";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.loader = false;
          this.error = response.data.error
          this.payoption = this.paymentoptions.find(
            (option) => option.set_default == 1
          );
          this.fetchSalesCart();
          this.$bvModal.hide("new-unit");
          this.category = "";
          this.product = "";
          this.unit = "";
          this.price = "";
          this.quantity = "";
        }
      });
    },
    async removeFromCart() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/deletefromcart";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSalesCart();
          this.error = '';
          this.$bvModal.hide("delete-unit");
        }
      });
    },
    async SubmitExit() {
      this.loader = true;
      this.loader3 = true;
      let obj = {
        cart: this.Cart,
        amount: this.amountpaid,
        total: this.cart_total,
        payoption: this.payoption.id,
        paydate: this.paydate,
        customer: this.useCustomer ? this.customer.id : "Unknown Customer",
      };
      let url = "/savecart";
      await axios.post(url, obj).then((response) => {
        if (response.data.error) {
          this.fetchSalesCart()
          this.error = response.data.error
          this.loader = false
          this.loader3 = false
        }
        if ((response.status == 200) && (!response.data.error)) {
          this.error = '';
          this.loader = false;
          this.loader3 = false;
          this.fetchSalesCart();
          this.$toast.success("New Medicine Sale Added");
        }
      });
    },
    async SubmitPrint() {
      this.loader = true;
      let obj = {
        cart: this.Cart,
        amount: this.amountpaid,
        total: this.cart_total,
        payoption: this.payoption.id,
        paydate: this.paydate,
        customer: this.useCustomer ? this.customer.id : "Unknown Customer",
      };
      let url = "/savecart";
      await axios.post(url, obj).then((response) => {
        if (response.data.error) {
          this.fetchSalesCart()
          this.error = response.data.error
          this.loader = false
        }
        if (response.status == 200 && !response.data.error) {
          this.error = ''
          this.loader = false;
          this.$router.push({
            path: "/printreciept",
            query: { id: response.data },
          });
          // this.$toast.success("New Medicine Sale Added");
        }
      });
    },
  },
};
</script>

<style>
  .no-glow:focus,
  .no-glow:active {
    box-shadow: none !important;
    outline: none !important;
  }
</style>
